module.exports = __webpack_public_path__ + "img/home.79fdcc05.svg";